import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'
import logger from 'lib/logger'

// All supported language names (always included in translations)
// Ordered alphabetically by Latin script, then Japanese
const ALL_LANGUAGE_NAMES = {
  de_DE: 'Deutsch',
  en_US: 'English',
  es_ES: 'Español',
  fr_FR: 'Français',
  it_IT: 'Italiano',
  nl_NL: 'Nederlands',
  ja_JP: '日本語'
}

// Returns available languages based on feature flag (used for language menu)
export function getAvailableLanguages() {
  let isSmartlingTranslationsEnabled = false
  try {
    isSmartlingTranslationsEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    logger.info('failed to check split-flag: EGD_React_Smartling_Translations')
  }

  if (isSmartlingTranslationsEnabled) {
    return ALL_LANGUAGE_NAMES
  }

  return {
    en_US: ALL_LANGUAGE_NAMES.en_US,
    es_ES: ALL_LANGUAGE_NAMES.es_ES,
    ja_JP: ALL_LANGUAGE_NAMES.ja_JP
  }
}

// Always export all language names for translations
export default {
  ess_language: {
    language: ALL_LANGUAGE_NAMES
  }
}
